<template>
    <ul class="list-unstyled" v-if="!hasSub">
        <li class="checkbox-group" v-for="cat in categories" :key="cat.id">
            <div class="arrow-block d-flex align-items-center justify-content-between mb-16">
                <div class="check-block">
                    <input
                        type="checkbox"
                        :id="'cat-check-'+cat.id"
                        class="sub-check-box"
                        :value="cat.id"
                        :checked="isChecked(cat)"
                        @change="toggleCategory(cat, $event.target.checked)"
                    >
                    <label :for="'cat-check-'+cat.id">{{ cat.name }}</label>
                </div>
            </div>
            <category-tree
                :has-sub="true"
                v-if="cat.children && cat.children.length"
                :categories="cat.children"
                v-model:selected="selectedProxy"
            />
        </li>
    </ul>
    <ul class="sub-checkboxes pl-16 mb-16" v-else>
        <li class="d-flex align-items-center gap-2 mb-12" v-for="cat in categories" :key="cat.id">
            <div class="check-block">
                <input
                    type="checkbox"
                    :id="'cat-check-'+cat.id"
                    :value="cat.id"
                    :checked="isChecked(cat)"
                    @change="toggleCategory(cat, $event.target.checked)"
                >
                <label :for="'cat-check-'+cat.id">{{ cat.name }}</label>
            </div>
        </li>
    </ul>
</template>

<style lang="scss">

</style>

<script>
export default {
    name: 'CategoryTree',
    emits: ['update:selected'],
    props: {
        categories: Array,
        hasSub: {
            type: Boolean,
            default: false,
        },
        selected: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        selectedProxy: {
            get() {
                return this.selected;
            },
            set(val) {
                this.$emit('update:selected', val);
            }
        },
    },
    methods: {
        // Проверяет, выбран ли элемент
        isChecked(cat) {
            return this.selectedProxy.includes(cat.id);
        },
        // Получает все id потомков (рекурсивно)
        getAllChildrenIds(cat) {
            let ids = [];
            if (cat.children && cat.children.length) {
                for (const child of cat.children) {
                    ids.push(child.id);
                    ids = ids.concat(this.getAllChildrenIds(child));
                }
            }
            return ids;
        },
        // Получить всех детей по parent_id (один уровень)
        getChildrenByParentId(parentId) {
            let result = [];
            const search = (cats) => {
                for (const c of cats) {
                    if (c.parent_id === parentId) result.push(c);
                    if (c.children && c.children.length) search(c.children);
                }
            };
            search(this.categories);
            return result;
        },
        // Найти категорию по id
        findCategoryById(id, cats = this.categories) {
            for (const cat of cats) {
                if (cat.id === id) return cat;
                if (cat.children && cat.children.length) {
                    const found = this.findCategoryById(id, cat.children);
                    if (found) return found;
                }
            }
            return null;
        },
        // Обработка выбора/снятия галочки
        toggleCategory(cat, checked) {
            let newSelected = [...this.selectedProxy];
            const childrenIds = this.getAllChildrenIds(cat);

            if (checked) {
                // Клик по родителю: выбираем родителя и всех потомков
                if (childrenIds.length) {
                    if (!newSelected.includes(cat.id)) newSelected.push(cat.id);
                    for (const id of childrenIds) {
                        if (!newSelected.includes(id)) newSelected.push(id);
                    }
                } else {
                    // Клик по дочернему: выбираем только себя
                    if (!newSelected.includes(cat.id)) newSelected.push(cat.id);
                    // Проверяем, выбраны ли все братья, если да — выбираем родителя
                    if (cat.parent_id) {
                        const siblings = this.getChildrenByParentId(cat.parent_id);
                        const allSiblingsSelected = siblings.every(child => newSelected.includes(child.id));
                        if (allSiblingsSelected && !newSelected.includes(cat.parent_id)) {
                            newSelected.push(cat.parent_id);
                        }
                    }
                }
            } else {
                // Клик по родителю: снимаем родителя и всех потомков
                if (childrenIds.length) {
                    newSelected = newSelected.filter(id => id !== cat.id && !childrenIds.includes(id));
                } else {
                    // Клик по дочернему: снимаем только себя
                    newSelected = newSelected.filter(id => id !== cat.id);
                    // Если родитель выбран — проверяем, остались ли выбранные братья
                    if (cat.parent_id) {
                        const siblings = this.getChildrenByParentId(cat.parent_id);
                        const allSiblingsSelected = siblings.every(child => newSelected.includes(child.id));
                        if (newSelected.includes(cat.parent_id) && !allSiblingsSelected) {
                            newSelected = newSelected.filter(id => id !== cat.parent_id);
                        }
                    }
                }
            }

            this.selectedProxy = newSelected;
        },
    },
}
</script>
